import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2, Link } from '@zola/zola-ui';

import { hideModal } from '../../../actions/modalActions';
import ZolaImageUploader from '../ZolaImageUploader';

const RejectBigPhotoUploadModal = ({ bytes, uploadProps }) => {
  return (
    <div>
      <div className="modal-header">
        <h2 className="modal-title">This Photo Is Too Big</h2>
      </div>
      <div className="modal-body">
        <div className="reject-photo-container">
          <p>
            The photo you have uploaded is <strong>{`${parseFloat(bytes).toFixed(2)} MB`}</strong>
          </p>
          <p>
            Please upload a photo <strong>smaller than 10MB</strong>
          </p>
          <p>
            For more on uploading photos, check out our{' '}
            <Link
              inline
              href="https://help.zola.com/hc/en-us/articles/360012943071-What-kinds-of-photos-can-I-upload-on-my-card"
            >
              FAQs.
            </Link>
          </p>
        </div>
      </div>
      <div className="modal-footer">
        <ZolaImageUploader
          {...uploadProps}
          inputId="reject_big_photo_uploader"
          renderButton={busy => (
            <ButtonV2 component="button" disabled={busy}>
              Change Photo
            </ButtonV2>
          )}
        />
      </div>
    </div>
  );
};

RejectBigPhotoUploadModal.propTypes = {
  bytes: PropTypes.number,
  uploadProps: PropTypes.shape({}),
};

const connectDispatchToProps = dispatch => ({
  onSubmit: () => dispatch(hideModal()),
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, connectDispatchToProps)(RejectBigPhotoUploadModal);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/RejectBigPhotoUploadModal.jsx